/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import FormNumberField, {
  FormNumberFieldProps
} from '../../../../client/js/components/form/fields/FormNumberField'
import { parseNumber } from '@jalik/form-parser'

function DurationField (props: FormNumberFieldProps) {
  const {
    name = 'duration',
    ...others
  } = props
  const intl = useIntl()
  return (
    <FormNumberField
      label={intl.formatMessage({
        id: 'duration',
        defaultMessage: 'Durée'
      })}
      name={name}
      parser={parseNumber}
      min={1}
      {...others}
    />
  )
}

export default DurationField
